<template>
  <Alert :title="lc.title" :content="lc.description" status="info">
    <template #actions>
      <Button
        :label="lc.wikiButton"
        href="https://www.locaweb.com.br/ajuda/categorias/criador-de-sites/"
        target="_blank"
        color="primary"
      />
    </template>
  </Alert>
</template>
<script>
import { Alert, Button, useLocale } from '@locaweb/design-system-vue'

export default {
  name: 'ImprovementAlert',
  components: {
    Alert,
    Button
  },
  setup () {
    const lc = useLocale('site.components.improvementAlert')

    return { lc }
  }
}
</script>
